import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { isLoggedIn } from "../../Utility/helper";
import PhoneIcon from "@mui/icons-material/Phone";
import CallMadeIcon from "@mui/icons-material/CallMade";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import "./dashboard.css";

// Import split components
import Dashboard1 from "./dashboard1";
import Dashboard2 from "./dashboard2";

const TelecallingDashboard = () => {
  const navigate = useNavigate();

  const [callSummary, setCallSummary] = useState([]);
  const [leadSummary, setLeadSummary] = useState([]);
  const [Statusthattime, setStatusthattime] = useState([]);
  const [activityLog, setActivityLog] = useState([]);
  const [loading, setLoading] = useState(true);

  const [dateFilter, setDateFilter] = useState("today");
  const [customRange, setCustomRange] = useState({ from: "", to: "" });

  const fetchDashboard = useCallback((userId) => {
    setLoading(true);

    let url = `https://be.corebankers.in/dashboard?userId=${userId}&filter=${dateFilter}`;
    if (dateFilter === "custom" && customRange.from && customRange.to) {
      url += `&fromDate=${customRange.from}&toDate=${customRange.to}`;
    }

    axios
      .get(url)
      .then((res) => {
        const { callSummary, leadSummary, pendingSnapshot, activityLog } = res.data;

        setCallSummary([
          { label: "Total Calls", value: callSummary.total_calls, icon: <PhoneIcon />, color: "#2563eb" },
          { label: "Connected", value: callSummary.connected, icon: <CallMadeIcon />, color: "#16a34a" },
          { label: "Unanswered", value: callSummary.no_answer, icon: <HourglassBottomIcon />, color: "#f59e0b" },
          { label: "Not Working", value: callSummary.not_working, icon: <HourglassBottomIcon />, color: "#ef4444" },
          { label: "Switched Off", value: callSummary.switched_off, icon: <HourglassBottomIcon />, color: "#6b7280" },
          { label: "Call Back", value: callSummary.call_back, icon: <HourglassBottomIcon />, color: "#0ea5e9" },
        ]);

        setLeadSummary([
          { label: "Loan Interested", value: leadSummary.interested, color: "#2563eb" },
          { label: "Not Interested", value: leadSummary.not_interested, color: "#ef4444" },
          { label: "Leads Qualified", value: leadSummary.leads_qualified, color: "#16a34a" },
          { label: "Doc. Picked", value: leadSummary.doc_picked, color: "#f59e0b" },
          { label: "Files Logged", value: leadSummary.files_logged, color: "#0ea5e9" },
          { label: "Files Approved", value: leadSummary.files_approved, color: "#10b981" },
          { label: "Files Rejected", value: leadSummary.files_rejected, color: "#ef4444" },
          { label: "Files Inprogress", value: leadSummary.files_inprogress, color: "#f97316" },
        ]);

        setStatusthattime([
          { label: "Pen. Loan Interested", value: pendingSnapshot.pending_interested },
          { label: "Pen. Lead Qualified", value: pendingSnapshot.pending_qualified },
          { label: "Pen. Documents Pick", value: pendingSnapshot.pending_doc_pick },
          { label: "Pen. Files Logged", value: pendingSnapshot.pending_files_logged },
          { label: "Pen. Daily Files Status", value: pendingSnapshot.pending_today_callbacks },
        ]);

        setActivityLog(
          activityLog.map((entry) => ({
            time: entry.time,
            leadName: entry.lead_name,
            mobile: entry.mobile,
            loanType: entry.loan_type,
            status: entry.status,
            remarks: entry.remarks,
            followUp: entry.follow_up,
            disposition: entry.disposition,
            executive: entry.executive,
          }))
        );

        setLoading(false);
      })
      .catch((err) => {
        console.error("Dashboard fetch failed:", err);
        setLoading(false);
      });
  }, [dateFilter, customRange]);

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
      return;
    }

    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      console.error("❌ No userId found in sessionStorage");
      navigate("/login");
      return;
    }

    fetchDashboard(userId);
  }, [navigate, fetchDashboard]);

  if (loading) return <CircularProgress sx={{ m: 4 }} />;

  return (
    <>
      <Dashboard1
        dateFilter={dateFilter}
        customRange={customRange}
        setDateFilter={setDateFilter}
        setCustomRange={setCustomRange}
        fetchDashboard={fetchDashboard}
        callSummary={callSummary}
        leadSummary={leadSummary}
        Statusthattime={Statusthattime}
      />
      <Dashboard2 activityLog={activityLog} />
    </>
  );
};

export default TelecallingDashboard;
